console.log("[custom-events] loaded",new Date().toISOString());(()=>{function closeGiftAccordion(e){const calendar=document.querySelector('#cc-calendar-overall');const giftAccordion=document.querySelector('.cart-note details');if(!calendar||!giftAccordion)return;if(calendar.contains(e.target)){giftAccordion.removeAttribute('open')}}
document.addEventListener('click',closeGiftAccordion);document.addEventListener('focusin',closeGiftAccordion)})();(function(){function addSitemapToPopover(){const popover=document.querySelector('anchored-popover-component .terms-policies-popover')
if(!popover)return
const list=popover.querySelector('ul.policy_list')
if(!list||list.querySelector('[data-sitemap-link]'))return
const li=document.createElement('li')
const a=document.createElement('a')
a.href='/pages/site-map'
a.className='footer-utilities__text'
a.textContent='Sitemap'
a.dataset.sitemapLink='true'
li.appendChild(a)
list.appendChild(li)}
document.addEventListener('DOMContentLoaded',addSitemapToPopover)
document.addEventListener('shopify:section:load',addSitemapToPopover)})();console.log("[custom-events] completed",new Date().toISOString());window.Shopify=window.Shopify||{}

/* ─────────────────────────────────────────
   Disable calendar dates (weekend cutoff)
───────────────────────────────────────── */
;(() => {
  const TZ = 'Europe/London'
 
  const fmt = (now, opt) =>
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...opt }).format(now)
 
  const iso = (now) =>
    new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(now)
 
  function targetIsos() {
    const now = new Date()
    const weekday = fmt(now, { weekday: 'short' })
    const hour = parseInt(fmt(now, { hour: '2-digit', hour12: false }), 10)
    const todayIso = iso(now)
 
    const addDays = (isoStr, days) => {
      const d = new Date(isoStr + 'T00:00:00Z')
      d.setUTCDate(d.getUTCDate() + days)
      return d.toISOString().slice(0, 10)
    }
 
    if (weekday === 'Sat' && hour >= 14)
      return [addDays(todayIso, 1), addDays(todayIso, 2)]
 
    if (weekday === 'Sun')
      return [todayIso, addDays(todayIso, 1)]
 
    return []
  }
 
  function apply(root = document) {
    const dates = targetIsos()
    if (!dates.length) return
 
    const table = root.querySelector('#cc-calendar-table')
    if (!table) return
 
    dates.forEach((d) => {
      table
        .querySelectorAll(`td[area-label="${d}"], td[aria-label="${d}"]`)
        .forEach((td) => {
          td.classList.remove('is-abled')
          td.classList.add('is-disabled')
          td.setAttribute('aria-disabled', 'true')
          td.tabIndex = -1
          td.style.pointerEvents = 'none'
          td.style.opacity = '0.45'
          td.style.cursor = 'not-allowed'
        })
    })
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true })
  } else {
    apply()
  }
 
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (
          n.nodeType === 1 &&
          (n.id === 'cc-calendar' ||
            n.querySelector?.('#cc-calendar-table'))
        ) {
          apply(n)
        }
      }
    }
  })
 
  mo.observe(document.documentElement, { childList: true, subtree: true })
 
  document.addEventListener('click', (e) => {
    if (
      e.target?.id === 'cc-next-button' ||
      e.target?.id === 'cc-back-button' ||
      e.target?.closest?.('#cc-next-button') ||
      e.target?.closest?.('#cc-back-button') ||
      e.target?.id === 'cc-calendar' ||
      e.target?.closest?.('#cc-calendar')
    ) {
      setTimeout(apply, 0)
    }
  })
 
  document.addEventListener('shopify:section:load', (e) => apply(e.target))
})()